import HeroSection from "../../components/staticView/homePageComponents/heroSection";
import Map from "../../components/staticView/homePageComponents/Map";
import ServiceCard from "../../components/staticView/homePageComponents/ServiceCard";
import TheDifference from "../../components/staticView/homePageComponents/theDifference";
import { useAppSelector } from "../../store/hooks";

const bannerImages = [
  "/Home/3shape.png",
  "/Home/carestream.png",
  "/Home/exocad.jpg",
  "/Home/itero.png",
  "/Home/medit.png",
  "/Home/planmeca.png",
  "/Home/sirona.png",
];

const Home = () => {
  const { user } = useAppSelector((state) => state.auth);

  const redirectUrl = user
    ? user.role === "User"
      ? "/dashboard/my-cases"
      : "/dashboard/admin/cases"
    : "/dashboard";

  return (
    <div className="bg-black text-white h-full w-full">
      <div className="w-full h-full relative md:pb-[5vw]">
        <HeroSection redirectUrl={redirectUrl} />
        <TheDifference />
        <div className="absolute -bottom-[5vw] left-0 w-full h-[80%] overflow-hidden md:flex hidden">
          <div className="w-full h-full flex flex-col items-center justify-center scale-125 rotate-12 opacity-65">
            <img
              src="/Home/wave1.svg"
              alt="Wave 1"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      <div className="w-full h-full p-8 md:p-[5vw]">
        <div className="w-full h-full flex flex-col md:flex-row gap-4 md:gap-[4vw] items-center justify-center">
          <div className="w-full md:w-[40%] h-full overflow-hidden">
            <img src="/Home/teeth_model.webp" alt="Teeth Model" />
          </div>
          <div className="w-full md:w-[60%] h-full flex flex-col gap-4 md:gap-[1vw]">
            <h1 className="text-3xl md:text-[2.5vw] font-bold md:leading-[3vw]">
              Leading Labs and Practices use ToothSketch
            </h1>
            <p className="text-lg md:text-[1.5vw] md:leading-[2vw] italic">
              “ToothSketch's reliable design service ensured my patient received
              a beautiful, perfectly fitted bridge quickly. Their precision and
              efficiency are unmatched.“ - Dental practitioner, London
            </p>
          </div>
        </div>
      </div>

      <div className="w-full h-[15vh] md:h-[8vw] bg-white flex items-center gap-[2vw] md:px-[5vw]">
        {bannerImages.map((item, index) => (
          <div key={index} className="w-full h-full selection:overflow-hidden">
            <img
              src={item}
              alt="images"
              className="w-full h-full object-contain"
            />
          </div>
        ))}
      </div>

      <div className="w-full h-full p-8 md:p-[5vw] flex flex-col gap-8 md:gap-[5vw] relative">
        <Map />
        <ServiceCard />
        <div className="absolute bottom-0 left-0 w-full h-[80%] overflow-hidden md:flex hidden">
          <div className="w-full h-full flex flex-col items-center justify-center scale-125 rotate-12 opacity-65">
            <img
              src="/Home/wave2.svg"
              alt="Wave 2"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
